import { Stage } from '../../missions/types';
import { ExercisesTypes, ExercisesAction, Exercise } from '../types';

export function getListExercises(exercises: Exercise[]): ExercisesAction<{ exercises: Exercise[] }> {
    return {
        type: ExercisesTypes.GET_LIST_EXERCISES,
        payload: { exercises },
    };
}

export function requestGetListExercises(ids: string[]): ExercisesAction<{ ids: string[] }> {
    return {
        type: ExercisesTypes.REQUEST_GET_LIST_EXERCISES,
        payload: { ids },
    };
}
export function saveExercises(exercises?: Exercise[]): ExercisesAction<{ exercises?: Exercise[] }> {
    return {
        type: ExercisesTypes.SAVE_EXERCISES,
        payload: { exercises },
    };
}

export function requestSaveExercises(exercises: Exercise[]): ExercisesAction<{ exercises: Exercise[] }> {
    return {
        type: ExercisesTypes.REQUEST_SAVE_EXERCISES,
        payload: { exercises },
    };
}

export function saveExercise(exercise?: Exercise): ExercisesAction<{ exercise?: Exercise }> {
    return {
        type: ExercisesTypes.SAVE_EXERCISE,
        payload: { exercise },
    };
}

export function requestSaveExercise(
    missionId: string,
    stage: Stage,
    exercise: Exercise,
): ExercisesAction<{ missionId: string; stage: Stage; exercise: Exercise }> {
    return {
        type: ExercisesTypes.REQUEST_SAVE_EXERCISE,
        payload: { missionId, stage, exercise },
    };
}

export function deleteExercise(id?: string): ExercisesAction<{ id?: string }> {
    return {
        type: ExercisesTypes.DELETE_EXERCISE,
        payload: { id },
    };
}

export function requestDeleteExercise(id: string, tasks?: string[]): ExercisesAction<{ id: string; tasks?: string[] }> {
    return {
        type: ExercisesTypes.REQUEST_DELETE_EXERCISE,
        payload: { id, tasks },
    };
}
